"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyRules;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _tinyInvariant = _interopRequireDefault(require("tiny-invariant"));

var _tinyWarning = _interopRequireDefault(require("tiny-warning"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _pipeP = _interopRequireDefault(require("./utils/pipeP"));

var _isValidObject = _interopRequireDefault(require("./utils/isValidObject"));

var _applyRulesResetCart = _interopRequireDefault(require("./applyRulesResetCart"));

var _resolveAndCallStrategy = _interopRequireDefault(require("./resolveAndCallStrategy"));

var _refreshCartTotal = _interopRequireDefault(require("./refreshCartTotal"));

var _ctxExtendResolveProduct = _interopRequireDefault(require("./ctxExtendResolveProduct"));

var _finalizeCartOutputPrices = _interopRequireDefault(require("./finalizeCartOutputPrices"));

var processRuleGroup = function processRuleGroup(_ref) {
  var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      superGroup = _ref2[0],
      superGroupRules = _ref2[1];

  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref3) {
      var _ref5, err, ctx, log, _ref6, _ref7, firstRule, _yield$resolveAndCall, _yield$resolveAndCall2, errPartial, nextContext, superGropLog, nextErr, nextLog, cartInput, deletedIndirect, cartWithDeleted, nextContextWithTotals;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref5 = (0, _slicedToArray2.default)(_ref3, 3), err = _ref5[0], ctx = _ref5[1], log = _ref5[2];
              _ref6 = superGroupRules || [], _ref7 = (0, _slicedToArray2.default)(_ref6, 1), firstRule = _ref7[0];

              if (firstRule) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", [err, ctx, log]);

            case 4:
              _context.next = 6;
              return (0, _resolveAndCallStrategy.default)(ctx, 'rule', firstRule.ruleType, superGroupRules);

            case 6:
              _yield$resolveAndCall = _context.sent;
              _yield$resolveAndCall2 = (0, _slicedToArray2.default)(_yield$resolveAndCall, 3);
              errPartial = _yield$resolveAndCall2[0];
              nextContext = _yield$resolveAndCall2[1];
              superGropLog = _yield$resolveAndCall2[2];
              nextErr = err === null && errPartial === null ? null : [].concat((0, _toConsumableArray2.default)(err || []), (0, _toConsumableArray2.default)(Array.isArray(errPartial) ? errPartial : [errPartial].filter(Boolean)));
              nextLog = [].concat((0, _toConsumableArray2.default)(log), [(0, _extends2.default)({
                superGroup: superGroup
              }, superGropLog)]);
              cartInput = ctx.cartInput;
              deletedIndirect = [].concat((0, _toConsumableArray2.default)(cartInput.subjects.reduce(function (x, y) {
                return [].concat((0, _toConsumableArray2.default)(x), (0, _toConsumableArray2.default)((y.indirectSubjects || []).filter(function (i) {
                  return i.deleted;
                }).map(function (i) {
                  return i.id;
                })));
              }, [])), (0, _toConsumableArray2.default)(((cartInput.shipping || {}).indirectSubjects || []).filter(function (i) {
                return i.deleted;
              }).map(function (i) {
                return i.id;
              })), (0, _toConsumableArray2.default)(((cartInput.payment || {}).indirectSubjects || []).filter(function (i) {
                return i.deleted;
              }).map(function (i) {
                return i.id;
              })), (0, _toConsumableArray2.default)((cartInput.indirectSubjects || []).filter(function (i) {
                return i.deleted;
              }).map(function (i) {
                return i.id;
              })));
              cartWithDeleted = (0, _extends2.default)({}, nextContext.cart, {
                subjects: nextContext.cart.subjects.reduce(function (c, s) {
                  return [].concat((0, _toConsumableArray2.default)(c), [(0, _extends2.default)({}, s, {
                    indirectSubjects: (s.indirectSubjects || []).map(function (i) {
                      return deletedIndirect.includes(i.id) ? (0, _extends2.default)({}, i, {
                        deleted: true
                      }) : i;
                    })
                  })]);
                }, []),
                shipping: (0, _extends2.default)({}, nextContext.cart.shipping, {
                  indirectSubjects: (nextContext.cart.shipping.indirectSubjects || []).map(function (i) {
                    return deletedIndirect.includes(i.id) ? (0, _extends2.default)({}, i, {
                      deleted: true
                    }) : i;
                  })
                }),
                payment: (0, _extends2.default)({}, nextContext.cart.payment, {
                  indirectSubjects: (nextContext.cart.payment.indirectSubjects || []).map(function (i) {
                    return deletedIndirect.includes(i.id) ? (0, _extends2.default)({}, i, {
                      deleted: true
                    }) : i;
                  })
                }),
                indirectSubjects: nextContext.cart.indirectSubjects.map(function (i) {
                  return deletedIndirect.includes(i.id) ? (0, _extends2.default)({}, i, {
                    deleted: true
                  }) : i;
                })
              }); // tu musime spravit este refresh cien kosiku

              nextContextWithTotals = (0, _extends2.default)({}, nextContext, {
                cart: (0, _refreshCartTotal.default)(cartWithDeleted)
              });
              return _context.abrupt("return", [nextErr, nextContextWithTotals, nextLog]);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var processRules = function processRules() {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(ctx) {
      var semi;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return ctx.rules.map(processRuleGroup).reduce( /*#__PURE__*/function () {
                var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(r, fn) {
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.t0 = fn;
                          _context2.next = 3;
                          return r;

                        case 3:
                          _context2.t1 = _context2.sent;
                          return _context2.abrupt("return", (0, _context2.t0)(_context2.t1));

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3, _x4) {
                  return _ref9.apply(this, arguments);
                };
              }(), Promise.resolve([null, ctx, []]));

            case 2:
              semi = _context3.sent;
              return _context3.abrupt("return", (0, _finalizeCartOutputPrices.default)(semi));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }();
};
/**
 *
 * @param {Object} ctx
 * @param {strtin} ctx.currency
 * @param {Object} ctx.cart
 * @param {Array<Object>} ctx.rules
 * @param {'B2C' | 'B2B' | 'B2BForeign'} ctx.pricesType
 * @param {function} ctx.productFinder
 */


function applyRules(_x5) {
  return _applyRules.apply(this, arguments);
}

function _applyRules() {
  _applyRules = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(ctx) {
    var pricesType, finalCtx;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            (0, _tinyInvariant.default)((0, _isValidObject.default)(ctx), 'applyRules() requires param `ctx` to be an `Object`.');
            (0, _tinyInvariant.default)((0, _isString.default)(ctx.currency), 'applyRules() required `currency` of type `string` to be a part of `ctx`.');
            (0, _tinyInvariant.default)((0, _isValidObject.default)(ctx.cart), 'applyRules() requires `cart` of type `Object` to be a part of `ctx`.');
            (0, _tinyInvariant.default)((0, _isArray.default)(ctx.rules), 'applyRules() requires `rules` of type `Array` to be a part of `ctx`.');
            (0, _tinyInvariant.default)((0, _isValidObject.default)(ctx.strategies), 'applyRules() requires `strategies` of type `Object` to be a part of `ctx`.');
            process.env.NODE_ENV !== "production" ? (0, _tinyWarning.default)((0, _isFunction.default)(ctx.productFinder), 'applyRules() will not be able to resolve products without defined `productFinder` as part of ctx.') : void 0;

            pricesType = function () {
              if (typeof ctx.pricesType === 'string' && ['B2C', 'B2B', 'B2BForeign'].includes(ctx.pricesType)) {
                return ctx.pricesType;
              } // Resolve `noTaxPrices` back compatibility...


              if (typeof ctx.noTaxPrices === 'boolean') {
                return ctx.noTaxPrices ? 'B2B' : 'B2C';
              }

              return 'B2C';
            }();

            finalCtx = (0, _ctxExtendResolveProduct.default)((0, _extends2.default)({
              decimalPrecision: 2,
              priceGroup: '_default',
              region: '_default'
            }, ctx, {
              pricesType: pricesType
            }));
            return _context4.abrupt("return", (0, _pipeP.default)((0, _applyRulesResetCart.default)(), processRules())(finalCtx));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _applyRules.apply(this, arguments);
}